import './sitefooter.scss';

import debounce from 'lodash.debounce';

class SiteFooter {
    constructor ($element) {
        this.$siteFooter = $element;
        this.$siteFooterToggle = this.$siteFooter.querySelectorAll('[data-sitefooter="areaToggle"]');
        this.initialize();
    }

    initialize () {
        this.changeA11yLabelsByState();
        this.changeA11yLabelsByVieport();
    }

    // Set Aria Labels for Accordion by State / On click or keydown
    changeA11yLabelsByState (state, disabled = false) {
        if (this.$siteFooterToggle.length > 0) {
            this.$siteFooterToggle.forEach($areaToggle => {
                let activeState = state;
                const $areaContent = $areaToggle.parentElement.parentElement.querySelector('[data-sitefooter="areaContent"]');

                // Init call - set Aria Labels by State
                this.setAreaState($areaToggle, $areaContent, activeState);

                if (disabled === true) {
                    $areaToggle.parentElement.setAttribute('role', 'presentation');
                    $areaToggle.setAttribute('role', 'presentation');
                    $areaToggle.removeAttribute('aria-selected');
                } else {
                    $areaToggle.parentElement.setAttribute('role', 'tablist');
                    $areaToggle.setAttribute('role', 'tab');
                }

                $areaToggle.onclick = () => {
                    activeState = !activeState;
                    this.setAreaState($areaToggle, $areaContent, activeState);
                };

                $areaToggle.addEventListener('keydown', (event) => {
                    if (event.code === 'Space' || event.code === 'Enter') {
                        event.preventDefault();
                        activeState = !activeState;
                        this.setAreaState($areaToggle, $areaContent, activeState);
                    }
                });
            });
        }
    }

    setAreaState (toggle, content, state) {
        if (state) {
            toggle.setAttribute('aria-selected', 'true');
            content.setAttribute('aria-hidden', 'false');
        } else {
            toggle.setAttribute('aria-selected', 'false');
            content.setAttribute('aria-hidden', 'true');
        }
    }

    // Set Aria Labels for Accordion by Viewport
    changeA11yLabelsByVieport () {
        const setTabindex = (tabIndexState) => {
            if (this.$siteFooterToggle.length > 0) {
                this.$siteFooterToggle.forEach($areaToggle => {
                    if (tabIndexState) {
                        $areaToggle.setAttribute('tabindex', 0);
                    } else {
                        $areaToggle.removeAttribute('tabindex');
                    }
                });
            }
        };

        const checkViewport = () => {
            if (window.innerWidth < 768) {
                setTabindex(true);
                this.changeA11yLabelsByState(false, false);
            } else {
                setTabindex(false);
                this.changeA11yLabelsByState(true, true);
            }
        };

        // Init call - check viewport and set Aria Labels
        checkViewport();

        window.addEventListener('resize', debounce(() => {
            checkViewport();
        }, 100));
    }
}

export default SiteFooter;
